import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import isEqual from 'lodash-es/isEqual';
import pickBy from 'lodash-es/pickBy';
import size from 'lodash-es/size';
import { PROVIDED_PROPS } from './removeProvidedProps';

export default function getModifiedProps(prevProps, currProps) {
  var childrenIsText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var children = currProps.children,
      rest = _objectWithoutProperties(currProps, ['children']);

  var modifiedProps = pickBy(rest, function (value, propName) {
    if (PROVIDED_PROPS.indexOf(propName) > -1) return false;

    return isEqual(value, prevProps[propName]) === false;
  });

  if (childrenIsText && isEqual(prevProps.children, children) === false) {
    modifiedProps.text = children;
  }

  if (size(modifiedProps) > 0) {
    return modifiedProps;
  }

  return false;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-jsx-highcharts/dist/es/utils/getModifiedProps.js
// module id = 22
// module chunks = 0